import React from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import { TitleContent } from './TitleContent';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { useDeliveryInfoMessage } from '../hooks/useDeliveryInfoMessage';

export const StandardDeliverySection = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const deliveryInfoMessage = useDeliveryInfoMessage();

  const isReserved =
    goodsBasic?.delivery_type_info.delivery_type === 'reserved';

  return (
    <TitleContent
      title={'배송정보'}
      tooltip={
        isReserved
          ? undefined
          : '제주도 및 도서산간 일부 지역의 경우, 추가 배송비가 발생할 수 있습니다.'
      }
    >
      <Flex gap={4}>
        <Typography type={'body2'}>{deliveryInfoMessage}</Typography>
      </Flex>
    </TitleContent>
  );
};
